import { createSelector } from 'reselect';
import _has from 'lodash/has';

/**
 * Direct selector to the sources state domain
 */

const selectSourcesDomain = state => state.sources;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Sources
 */

const makeSelectProcessing = () =>
  createSelector(
    selectSourcesDomain,
    substate => substate.processing,
  );
const makeSelectFaq = () =>
  createSelector(
    selectSourcesDomain,
    substate => (_has(substate.data, 'FAQ') ? substate.data.FAQ : null),
  );
const makeSelectFactoid = () =>
  createSelector(
    selectSourcesDomain,
    substate => (_has(substate.data, 'Factoid') ? substate.data.Factoid : null),
  );
const makeSelectClientExclusive = () =>
  createSelector(
    selectSourcesDomain,
    substate =>
      _has(substate.data, 'Client Exclusive')
        ? substate.data['Client Exclusive']
        : null,
  );
const makeSelectCitation = () =>
  createSelector(
    selectSourcesDomain,
    substate =>
      _has(substate.data, 'Citation') ? substate.data.Citation : null,
  );
const makeSelectRecommendedFactoids = () =>
  createSelector(
    selectSourcesDomain,
    substate => substate.recommendedFactoids,
  );
const makeSelectGuideMe = () =>
  createSelector(
    selectSourcesDomain,
    substate =>
      _has(substate.data, 'Guide Me') ? substate.data['Guide Me'] : null,
  );
export {
  makeSelectProcessing,
  makeSelectFaq,
  makeSelectFactoid,
  makeSelectClientExclusive,
  makeSelectRecommendedFactoids,
  makeSelectCitation,
  makeSelectGuideMe,
};
